import { React, useEffect, useState } from "react";
import { useGlobalContext } from "../context";
import Board from "./Board";
let stockfish = new Worker("stockfish11.js");

const GameBoard = ({ chess }) => {
  const {
    setPgn,
    setFen,
    setIsGameOver,
    setLetRedo,
    piecesColor,
    resetBoard,
    engineStrength,
    gameAgainstComputer,
  } = useGlobalContext();

  const setFenAndPgn = () => {
    setLetRedo(false);
    setFen(chess.fen());
    setPgn(chess.pgn());
    setIsGameOver(chess.game_over());
  };

  const [engineSettings, setEngineSettings] = useState({
    skillLevel: 0,
    skillError: 900,
    skillProbability: 10,
  });

  const setEngineValues = (skillLevel, skillError, skillProbability) => {
    setEngineSettings({
      skillLevel,
      skillError,
      skillProbability,
    });
  };

  useEffect(() => {
    if (engineStrength == 800) {
      setEngineValues(0, 500, 10);
    } else if (engineStrength == 900) {
      setEngineValues(0, 200, 10);
    } else if (engineStrength == 1000) {
      setEngineValues(0, 200, 70);
    } else if (engineStrength == 1100) {
      setEngineValues(0, 200, 128);
    } else if (engineStrength == 1200) {
      setEngineValues(2, 200, 128);
    } else if (engineStrength == 1300) {
      setEngineValues(3, 200, 128);
    }
  }, []);

  // make computer move (stockfish 11) or original engine
  const computerMove = () => {
    let fen = chess.fen();
    if (gameAgainstComputer) {
      stockfish.postMessage("uci");
      stockfish.postMessage(
        `setoption name Skill Level value ${engineSettings.skillLevel}`
      );
      stockfish.postMessage(
        `setoption name Skill Level Maximum Error value ${engineSettings.skillError}`
      );
      stockfish.postMessage(
        `setoption name Skill Level Probability value ${engineSettings.skillProbability}`
      );
      stockfish.postMessage("ucinewgame");
      stockfish.postMessage(`position fen ${fen}`);
      stockfish.postMessage(`go depth 1`);
      stockfish.onmessage = (e) => {
        let data = JSON.stringify(e.data);
        if (data.startsWith('"bestmove')) {
          let move = data.split(" ")[1];
          setTimeout(() => {
            chess.move({
              from: move.slice(0, 2),
              to: move.slice(2, 4),
              promotion: "q",
            });
            setFenAndPgn();
            if (chess.game_over()) {
              setIsGameOver(true);
            }
          }, 3000);
        }
      };
    } else {
      if (!chess.game_over()) {
        try {
          fetch("https://chess-tutor-api.herokuapp.com/engine_best_move/", {
            method: "POST",
            credentials: "omit",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              fen: fen,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              let move = data.move;
              setTimeout(() => {
                chess.move({
                  from: move.slice(0, 2),
                  to: move.slice(2, 4),
                  promotion: "q",
                });
                setFenAndPgn();
                if (chess.game_over()) {
                  setIsGameOver(true);
                }
              }, 2000);
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  // if user is black, make computer move first
  useEffect(() => {
    setTimeout(() => {
      if (
        (piecesColor && chess.turn() === "b") ||
        (!piecesColor && chess.turn() === "w")
      ) {
        computerMove();
      }
    }, 1000);
  }, [resetBoard, piecesColor, chess]);

  // handle user's turn and make a computer move
  const handleMove = (from, to) => {
    if (chess.move({ from, to, promotion: "q" })) {
      setFenAndPgn();
      if (!chess.game_over()) computerMove();
    }
  };

  // show and let valid moves for users color
  const calcMovable = () => {
    const dests = new Map();
    chess.SQUARES.forEach((s) => {
      const ms = chess.moves({ square: s, verbose: true });
      if (ms.length)
        dests.set(
          s,
          ms.map((m) => m.to)
        );
    });

    return {
      free: false,
      dests,
      color: piecesColor ? "white" : "black",
    };
  };

  return (
    <>
      <Board chess={chess} handleMove={handleMove} calcMovable={calcMovable} />
    </>
  );
};

export default GameBoard;
